import React, {lazy, Suspense} from 'react'

const MassTimesPageLazy = lazy(() => import('./MassTimesPage'))

const MassTimesPage = props => (
  <Suspense fallback={null}>
    <MassTimesPageLazy {...props}/>
  </Suspense>
)

export default MassTimesPage
